import { render, staticRenderFns } from "./CustomerBase.vue?vue&type=template&id=76c185d7&"
import script from "./CustomerBase.vue?vue&type=script&lang=js&"
export * from "./CustomerBase.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports